import { render, staticRenderFns } from "./RentCarousel.vue?vue&type=template&id=ed5e8fb8&scoped=true&"
import script from "./RentCarousel.vue?vue&type=script&lang=js&"
export * from "./RentCarousel.vue?vue&type=script&lang=js&"
import style0 from "./RentCarousel.vue?vue&type=style&index=0&id=ed5e8fb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5e8fb8",
  null
  
)

export default component.exports